import ForeignBornDocuments from './ForeignBornDocuments';

export default ForeignBornDocuments;
